import React from 'react';

export const OurWork = () => {
  return (
    <div className='MainWrapper'>
      <p>THIS IS Services PAGE</p>
    </div>
  );
};
